module.exports = __webpack_public_path__ + "img/lightening.cd5a2eeb.svg";